module.exports = __webpack_public_path__ + "images/group-hd-bg-a061c89a47da97eee3594af171e8fad8.gif";